export enum ArrowState {
    BOTH,
    UP,
    DOWN,
}